import { useQuery } from '@apollo/client/react';

import {
  SmartMeterBookingInput,
  ThankYouBasketFragment,
} from '@generated/gql/graphql';

import { SmartMeter } from './SmartMeter';
import { getSmartLinkQuery, smartMeterBookingInput } from './query';

interface SmartMeterBookingProps {
  basket: ThankYouBasketFragment;
}

const SmartMeterBooking = ({ basket }: SmartMeterBookingProps) => {
  const smartBookingLinkQueryInput = smartMeterBookingInput(basket);

  if (smartBookingLinkQueryInput) {
    return (
      <SmartMeterUnwrapped
        smartBookingQueryInput={smartBookingLinkQueryInput}
      />
    );
  } else {
    return null;
  }
};

const SmartMeterUnwrapped = ({
  smartBookingQueryInput,
}: {
  smartBookingQueryInput: SmartMeterBookingInput;
}) => {
  const { data } = useQuery(getSmartLinkQuery, {
    variables: { input: smartBookingQueryInput },
  });

  if (data?.smartMeterBooking?.eligible && data?.smartMeterBooking?.link) {
    return <SmartMeter link={data.smartMeterBooking.link} />;
  } else {
    return null;
  }
};

export { SmartMeterBooking };
